import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from 'primereact/multiselect';

function AddNewShareholder() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [portfolios, setPortfolios] = useState([]);
  const [selectedPortfolios, setSelectedPortfolios] = useState([]);
  const [selectedSpanishPortfolios, setSelectedSpanishPortfolios] = useState([]);
  const [activeLanguage, setActiveLanguage] = useState('en');

  const [formData, setFormData] = useState({
    language: 'en',
    title: '',
    description: '',
    featuredImage: null,
    clients: null,
    led: '',
    space: '',
    // slug: '',
    isFeatured: false,
    isHomePageFeatured: false
  });

  const [spanishData, setSpanishData] = useState({
    language: 'es',
    title: '',
    description: '',
    led: '',
    space: '',
    clients: [],
    services: [],
    portfolios: [],
    reviews: [],
    // slug: ''
  });

  const [services, setServices] = useState([
    { title: '', description: '', image: null }
  ]);

  const [reviews, setReviews] = useState([
    { title: '', description: '', image: null }
  ]);

  const [spanishServices, setSpanishServices] = useState([
    { title: '', description: '', image: null }
  ]);

  const [spanishReviews, setSpanishReviews] = useState([
    { title: '', description: '', image: null }
  ]);

  // Services
  const handleServicesChange = (index, event) => {
    const newFields = services.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setServices(newFields);
  };

  const addServicesFields = () => {
    setServices([...services, { title: '', description: '', image: null }]);
  };

  const removeServicesFields = (index) => {
    const newFields = services.filter((field, fieldIndex) => index !== fieldIndex);
    setServices(newFields);
  };

  const handleServicesImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = services.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setServices(newFields);
  };

  // Reviews change
  const handleReviewsChange = (index, event) => {
    const newFields = reviews.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setReviews(newFields);
  };

  const addReviewsFields = () => {
    setReviews([...reviews, { title: '', description: '', image: null }]);
  };

  const removeReviewsFields = (index) => {
    const newFields = reviews.filter((field, fieldIndex) => index !== fieldIndex);
    setReviews(newFields);
  };

  const handleReviewsImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = reviews.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setReviews(newFields);
  };

  // Spanish Services
  const handleSpanishServicesChange = (index, event) => {
    const newFields = spanishServices.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setSpanishServices(newFields);
  };

  const addSpanishServicesFields = () => {
    setSpanishServices([...spanishServices, { title: '', description: '', image: null }]);
  };

  const removeSpanishServicesFields = (index) => {
    const newFields = spanishServices.filter((field, fieldIndex) => index !== fieldIndex);
    setSpanishServices(newFields);
  };

  const handleSpanishServicesImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = spanishServices.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setSpanishServices(newFields);
  };

  // Spanish Reviews
  const handleSpanishReviewsChange = (index, event) => {
    const newFields = spanishReviews.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: event.target.value };
      }
      return field;
    });
    setSpanishReviews(newFields);
  };

  const addSpanishReviewsFields = () => {
    setSpanishReviews([...spanishReviews, { title: '', description: '', image: null }]);
  };

  const removeSpanishReviewsFields = (index) => {
    const newFields = spanishReviews.filter((field, fieldIndex) => index !== fieldIndex);
    setSpanishReviews(newFields);
  };

  const handleSpanishReviewsImageChange = (index, event) => {
    const image = event.target.files;
    const newFields = spanishReviews.map((field, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...field, [event.target.name]: image[0] };
      }
      return field;
    });

    setSpanishReviews(newFields);
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };

  const handleSpanishInputChange = (e) => {
    const { name, value } = e.target;
    setSpanishData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const fetchPortfolios = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/admin/get-portfolios`, { withCredentials: true });

      if (response.data) {
        setPortfolios(response.data);
      }

    } catch (err) {
      console.log('Failed to fetch portfolios');
    }
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append('image', image);

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data?.image;
    } catch (error) {
      console.error('Image upload failed:', error);
      return null;
    }
  };

  const handleAddLocation = async (e) => {
    e.preventDefault();
    const data = new FormData();
    // English/base fields
    data.append('language', formData.language);
    data.append('title', formData.title);
    data.append('description', formData.description);
    data.append('led', formData.led);
    data.append('space', formData.space);
    // data.append('slug', formData.slug);
    data.append('isFeatured', formData.isFeatured);
    data.append('isHomePageFeatured', formData.isHomePageFeatured);

    // Spanish translation (no files here; files are shared)
    data.append('spanishData', JSON.stringify({
      language: 'es',
      title: spanishData.title || '',
      description: spanishData.description || '',
      led: spanishData.led || '',
      space: spanishData.space || '',
      clients: spanishData.clients || [],
      services: [], // Will be populated separately
      portfolios: selectedSpanishPortfolios || [],
      reviews: [], // Will be populated separately
      // slug: spanishData.slug || ''
    }));

    if (selectedPortfolios.length > 0) {
      data.append('portfolios', JSON.stringify(selectedPortfolios));
    }

    if (selectedSpanishPortfolios.length > 0) {
      data.append('spanishPortfolios', JSON.stringify(selectedSpanishPortfolios));
    }

    if (formData.clients) {
      for (let i = 0; i < formData.clients.length; i++) {
        data.append('clients', formData.clients[i]);
      }
    }

    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    // English Services
    if (services.length > 0) {
      var updatedServices = [];
      await Promise.all(services.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image == "object") {
            var imageData = await handleImageUpload(item?.image);
            updatedServices.push({ title: item.title, description: item.description, image: imageData });
          } else {
            updatedServices.push({ title: item.title, description: item.description, image: item?.image });
          }
        } else {
          updatedServices.push({ title: item.title, description: item.description, image: null });
        }
      }));
      data.append('services', JSON.stringify(updatedServices));
    }

    // English Reviews
    if (reviews.length > 0) {
      var updatedReviews = [];
      await Promise.all(reviews.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image == "object") {
            var imageData = await handleImageUpload(item?.image);
            updatedReviews.push({ title: item.title, description: item.description, image: imageData });
          } else {
            updatedReviews.push({ title: item.title, description: item.description, image: item?.image });
          }
        } else {
          updatedReviews.push({ title: item.title, description: item.description, image: null });
        }
      }));
      data.append('reviews', JSON.stringify(updatedReviews));
    }

    // Spanish Services
    if (spanishServices.length > 0) {
      var updatedSpanishServices = [];
      await Promise.all(spanishServices.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image == "object") {
            var imageData = await handleImageUpload(item?.image);
            updatedSpanishServices.push({ title: item.title, description: item.description, image: imageData });
          } else {
            updatedSpanishServices.push({ title: item.title, description: item.description, image: item?.image });
          }
        } else {
          updatedSpanishServices.push({ title: item.title, description: item.description, image: null });
        }
      }));
      data.append('spanishServices', JSON.stringify(updatedSpanishServices));
    }

    // Spanish Reviews
    if (spanishReviews.length > 0) {
      var updatedSpanishReviews = [];
      await Promise.all(spanishReviews.map(async (item, index) => {
        if (item?.image) {
          if (typeof item?.image == "object") {
            var imageData = await handleImageUpload(item?.image);
            updatedSpanishReviews.push({ title: item.title, description: item.description, image: imageData });
          } else {
            updatedSpanishReviews.push({ title: item.title, description: item.description, image: item?.image });
          }
        } else {
          updatedSpanishReviews.push({ title: item.title, description: item.description, image: null });
        }
      }));
      data.append('spanishReviews', JSON.stringify(updatedSpanishReviews));
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-shareholder`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/shareholders');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add shareholder');
    }
  };

  useEffect(() => {
    fetchPortfolios();
  }, []);

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button
                type="button"
                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                onClick={() => setActiveLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                English
              </button>
              <button
                type="button"
                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                onClick={() => setActiveLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleAddLocation} encType="multipart/form-data">
              <div className="language-content">
                {/* English Content */}
                {activeLanguage === 'en' && (
                  <div className="language-content">
                    <h3>English Content</h3>
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Description (English)</h2>
                      <input
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Led (English)</h2>
                      <input
                        type="text"
                        name="led"
                        value={formData.led}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Space (English)</h2>
                      <input
                        type="text"
                        name="space"
                        value={formData.space}
                        onChange={(e) => handleInputChange(e.target)}
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (English)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="url-friendly-slug"
                        required
                      />
                    </div> */}
                  </div>
                )}

                {/* Spanish Content */}
                {activeLanguage === 'es' && (
                  <div className="language-content">
                    <h3>Spanish Content</h3>
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={spanishData.title}
                        onChange={handleSpanishInputChange}
                        placeholder="Título"
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Description (English)</h2>
                      <input
                        type="text"
                        name="description"
                        value={spanishData.description}
                        onChange={handleSpanishInputChange}
                        placeholder="Descripción"
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Led (Spanish)</h2>
                      <input
                        type="text"
                        name="led"
                        value={spanishData.led}
                        onChange={handleSpanishInputChange}
                      />
                    </div>

                    <div className="add_field textareaField">
                      <h2>Space (Spanish)</h2>
                      <input
                        type="text"
                        name="space"
                        value={spanishData.space}
                        onChange={handleSpanishInputChange}
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (Spanish)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={spanishData.slug}
                        onChange={handleSpanishInputChange}
                        placeholder="slug-amigable"
                      />
                    </div> */}

                    <div className="add_field textareaField">
                      <h2>Select Portfolios (Spanish)</h2>
                      <MultiSelect
                        value={selectedSpanishPortfolios}
                        onChange={(e) => setSelectedSpanishPortfolios(e.value)}
                        options={portfolios}
                        optionLabel="title"
                        placeholder="Seleccionar Portafolios"
                        maxSelectedLabels={3}
                        className="w-full md:w-20rem"
                      />
                    </div>

                    <div className="add_field textareaField repeaterFields">
                      <h2>Services (Spanish)</h2>
                      {spanishServices.map((field, index) => (
                        <div key={index} className="singleReapterFieldContent">
                          <div className="add_field">
                            <h2>Title</h2>
                            <input
                              name="title"
                              type="text"
                              value={field.title}
                              placeholder="Título"
                              onChange={(event) => handleSpanishServicesChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h2>Description</h2>
                            <input
                              name="description"
                              type="text"
                              value={field.description}
                              placeholder="Descripción"
                              onChange={(event) => handleSpanishServicesChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h2>Image</h2>
                            <div className="form-group">
                              <div className="file-upload">
                                <input
                                  type="file"
                                  className="form-control"
                                  name="image"
                                  onChange={(event) => handleSpanishServicesImageChange(index, event)}
                                  multiple
                                />
                                <i className="fa fa-camera i-pic-upload"></i>
                              </div>
                            </div>
                          </div>

                          <button type="button" onClick={() => removeSpanishServicesFields(index)}>
                            Remove
                          </button>
                        </div>
                      ))}
                      <button type="button" onClick={addSpanishServicesFields}>Agregar Más</button>
                    </div>

                    <div className="add_field textareaField repeaterFields">
                      <h2>Reviews (Spanish)</h2>
                      {spanishReviews.map((field, index) => (
                        <div key={index} className="singleReapterFieldContent">
                          <div className="add_field">
                            <h2>Title</h2>
                            <input
                              name="title"
                              type="text"
                              value={field.title}
                              placeholder="Título"
                              onChange={(event) => handleSpanishReviewsChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h2>Description</h2>
                            <input
                              name="description"
                              type="text"
                              value={field.description}
                              placeholder="Descripción"
                              onChange={(event) => handleSpanishReviewsChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h2>Image</h2>
                            <div className="form-group">
                              <div className="file-upload">
                                <input
                                  type="file"
                                  className="form-control"
                                  name="image"
                                  onChange={(event) => handleSpanishReviewsImageChange(index, event)}
                                  multiple
                                />
                                <i className="fa fa-camera i-pic-upload"></i>
                              </div>
                            </div>
                          </div>

                          <button type="button" onClick={() => removeSpanishReviewsFields(index)}>
                            Remove
                          </button>
                        </div>
                      ))}
                      <button type="button" onClick={addSpanishReviewsFields}>Agregar Más</button>
                    </div>
                  </div>
                )}

                <div className="add_field">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>

                <div className="add_field">
                  <h2>Clients</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="clients"
                        multiple
                        onChange={(e) => handleInputChange(e.target)}
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>
                {activeLanguage === 'en' && (
                  <div className="add_field textareaField">
                    <h2>Select Portfolios</h2>
                    <MultiSelect
                      value={selectedPortfolios}
                      onChange={(e) => setSelectedPortfolios(e.value)}
                      options={portfolios}
                      optionLabel="title"
                      placeholder="Select Portfolios"
                      maxSelectedLabels={3}
                      className="w-full md:w-20rem"
                    />
                  </div>)}
                {activeLanguage === 'en' && (
                  <div className="add_field textareaField repeaterFields">
                    <h2>Services</h2>
                    {services.map((field, index) => (
                      <div key={index} className="singleReapterFieldContent">
                        <div className="add_field">
                          <h2>Title</h2>
                          <input
                            name="title"
                            type="text"
                            value={field.title}
                            placeholder="Title"
                            onChange={(event) => handleServicesChange(index, event)}
                          />
                        </div>

                        <div className="add_field">
                          <h2>Description</h2>
                          <input
                            name="description"
                            type="text"
                            value={field.description}
                            placeholder="Description"
                            onChange={(event) => handleServicesChange(index, event)}
                          />
                        </div>

                        <div className="add_field">
                          <h2>Image</h2>
                          <div className="form-group">
                            <div className="file-upload">
                              <input
                                type="file"
                                className="form-control"
                                name="image"
                                onChange={(event) => handleServicesImageChange(index, event)}
                                multiple
                              />
                              <i className="fa fa-camera i-pic-upload"></i>
                            </div>
                          </div>
                        </div>

                        <button type="button" onClick={() => removeServicesFields(index)}>
                          Remove
                        </button>
                      </div>
                    ))}
                    <button type="button" onClick={addServicesFields}>Add More</button>
                  </div>
                )}
                {activeLanguage === 'en' && (
                  <div className="add_field textareaField repeaterFields">
                    <h2>Reviews</h2>
                    {reviews.map((field, index) => (
                      <div key={index} className="singleReapterFieldContent">
                        <div className="add_field">
                          <h2>Title</h2>
                          <input
                            name="title"
                            type="text"
                            value={field.title}
                            placeholder="Title"
                            onChange={(event) => handleReviewsChange(index, event)}
                          />
                        </div>

                        <div className="add_field">
                          <h2>Description</h2>
                          <input
                            name="description"
                            type="text"
                            value={field.description}
                            placeholder="Description"
                            onChange={(event) => handleReviewsChange(index, event)}
                          />
                        </div>

                        <div className="add_field">
                          <h2>Image</h2>
                          <div className="form-group">
                            <div className="file-upload">
                              <input
                                type="file"
                                className="form-control"
                                name="image"
                                onChange={(event) => handleReviewsImageChange(index, event)}
                                multiple
                              />
                              <i className="fa fa-camera i-pic-upload"></i>
                            </div>
                          </div>
                        </div>

                        <button type="button" onClick={() => removeReviewsFields(index)}>
                          Remove
                        </button>
                      </div>
                    ))}
                    <button type="button" onClick={addReviewsFields}>Add More</button>
                  </div>
                )}
                <div className="add_field checkbox_field">
                  <Checkbox
                    onChange={(e) => setFormData({ ...formData, isFeatured: e.checked })}
                    checked={formData.isFeatured}
                  ></Checkbox>
                  <h4>Is Featured?</h4>
                </div>

                <div className="add_field checkbox_field">
                  <Checkbox
                    onChange={(e) => setFormData({ ...formData, isHomePageFeatured: e.checked })}
                    checked={formData.isHomePageFeatured}
                  ></Checkbox>
                  <h4>Is HomePage Featured?</h4>
                </div>
              </div>

              <div className="add_project">
                <button type="submit">Add Shareholder</button>
              </div>

            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewShareholder;
